module.exports = __webpack_public_path__ + "static/img/9.dbee9b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/9.png
// module id = WubC
// module chunks = 0